import script from "./RechargeTips.vue?vue&type=script&setup=true&lang=js"
export * from "./RechargeTips.vue?vue&type=script&setup=true&lang=js"

import "./RechargeTips.vue?vue&type=style&index=0&id=e75d0b64&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e75d0b64"]])

export default __exports__